export default class ChatBotTipoNoApiVerboTiposEnum {
    static Get = 1
    static Post = 2
    static Put = 3
    static Delete = 4
}
